var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "resources-feed__filters-wrapper" }, [
    _c(
      "div",
      {
        staticClass:
          "resources-feed__filters resources-filters resources-filters--desktop"
      },
      [
        _c("span", [_vm._v("Filter your search:")]),
        _vm._v(" "),
        _vm._l(_vm.taxonomies, function(taxonomy) {
          return _c(
            "button",
            {
              key: taxonomy.taxonomy_name,
              staticClass: "resources-filters__taxonomy",
              class:
                _vm.activeTaxonomy === taxonomy.taxonomy_name
                  ? "resources-filters__taxonomy--active"
                  : "",
              attrs: { title: taxonomy.taxonomy_name },
              on: {
                click: function($event) {
                  return _vm.showTerms(taxonomy.taxonomy_name)
                }
              }
            },
            [_vm._v("\n      " + _vm._s(taxonomy.taxonomy_name) + "\n    ")]
          )
        }),
        _vm._v(" "),
        Object.keys(_vm.currentTaxonomies).length > 0
          ? _c(
              "div",
              { staticClass: "resources-filters__selected-filters" },
              [
                _c("span", [_vm._v("Filters currently selected: ")]),
                _vm._v(" "),
                _vm._l(_vm.currentTaxonomies, function(terms, index) {
                  return _c(
                    "div",
                    { key: index },
                    _vm._l(terms, function(term, i) {
                      return _c("span", { key: i }, [_vm._v(_vm._s(term))])
                    }),
                    0
                  )
                }),
                _vm._v(" "),
                Object.keys(_vm.currentTaxonomies).length !== 0
                  ? _c("button", {
                      staticClass: "resources-filters__clear",
                      attrs: { title: "Clear Filters" },
                      on: { click: _vm.clearCurrentTaxonomies }
                    })
                  : _vm._e()
              ],
              2
            )
          : _vm._e()
      ],
      2
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass:
          "resources-filters__wrapper resources-filters__wrapper--desktop container--1240"
      },
      [
        _vm._l(_vm.taxonomies, function(taxonomy, index) {
          return [
            _vm.activeTaxonomy === taxonomy.taxonomy_name
              ? _c(
                  "div",
                  { key: index, staticClass: "resources-filters__terms" },
                  _vm._l(taxonomy.terms, function(term) {
                    return _c(
                      "button",
                      {
                        key: term.term_id,
                        staticClass: "resources-filters__term",
                        class: {
                          "resources-filters__term--active":
                            Object.hasOwn(
                              _vm.currentTaxonomies,
                              term.taxonomy
                            ) &&
                            _vm.currentTaxonomies[term.taxonomy].includes(
                              term.name
                            )
                        },
                        attrs: { title: term.name },
                        on: {
                          click: function($event) {
                            _vm.selectTerm(term), _vm.toggleClass($event)
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n          " + _vm._s(term.name) + "\n        "
                        )
                      ]
                    )
                  }),
                  0
                )
              : _vm._e()
          ]
        })
      ],
      2
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass:
          "resources-feed__filters resources-filters resources-filters--mobile",
        class: { "resources-filters--active": _vm.showFilters }
      },
      [
        _c(
          "div",
          { staticClass: "resources-filters__top" },
          [
            _c("span", [_vm._v("Filter your search:")]),
            _vm._v(" "),
            _vm._l(_vm.taxonomies, function(taxonomy) {
              return _c(
                "button",
                {
                  key: taxonomy.taxonomy_name,
                  staticClass: "resources-filters__taxonomy",
                  class:
                    _vm.activeTaxonomy === taxonomy.taxonomy_name
                      ? "resources-filters__taxonomy--active"
                      : "",
                  attrs: { title: taxonomy.taxonomy_name },
                  on: {
                    click: function($event) {
                      return _vm.showTerms(taxonomy.taxonomy_name)
                    }
                  }
                },
                [
                  _vm._v(
                    "\n        " + _vm._s(taxonomy.taxonomy_name) + "\n      "
                  )
                ]
              )
            })
          ],
          2
        ),
        _vm._v(" "),
        Object.keys(_vm.currentTaxonomies).length > 0
          ? _c(
              "div",
              { staticClass: "resources-filters__selected-filters" },
              [
                _c("span", [_vm._v("Filters currently selected: ")]),
                _vm._v(" "),
                _vm._l(_vm.currentTaxonomies, function(terms, index) {
                  return _c(
                    "div",
                    { key: index },
                    _vm._l(terms, function(term, i) {
                      return _c("span", { key: i }, [_vm._v(_vm._s(term))])
                    }),
                    0
                  )
                }),
                _vm._v(" "),
                Object.keys(_vm.currentTaxonomies).length !== 0
                  ? _c("button", {
                      staticClass: "resources-filters__clear",
                      attrs: { title: "Clear Filters" },
                      on: { click: _vm.clearCurrentTaxonomies }
                    })
                  : _vm._e()
              ],
              2
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "resources-filters__wrapper resources-filters__wrapper--mobile"
          },
          [
            _vm._l(_vm.taxonomies, function(taxonomy, index) {
              return [
                _vm.activeTaxonomy === taxonomy.taxonomy_name
                  ? _c(
                      "div",
                      { key: index, staticClass: "resources-filters__terms" },
                      _vm._l(taxonomy.terms, function(term) {
                        return _c(
                          "button",
                          {
                            key: term.term_id,
                            staticClass: "resources-filters__term",
                            class: {
                              "resources-filters__term--active":
                                Object.hasOwn(
                                  _vm.currentTaxonomies,
                                  term.taxonomy
                                ) &&
                                _vm.currentTaxonomies[term.taxonomy].includes(
                                  term.name
                                )
                            },
                            attrs: { title: term.name },
                            on: {
                              click: function($event) {
                                _vm.selectTerm(term), _vm.toggleClass($event)
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(term.name) +
                                "\n          "
                            )
                          ]
                        )
                      }),
                      0
                    )
                  : _vm._e()
              ]
            }),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass:
                  "btn btn--large btn--orange resources-filters__button",
                attrs: { title: "Apply Filters" },
                on: {
                  click: function($event) {
                    _vm.showFilters = false
                  }
                }
              },
              [_vm._v("\n        Apply Filters\n      ")]
            )
          ],
          2
        )
      ]
    ),
    _vm._v(" "),
    _c(
      "button",
      {
        staticClass: "resources-filters__filter btn btn--purple btn--smallest",
        attrs: { title: "Filter your search" },
        on: {
          click: function($event) {
            _vm.showFilters = true
          }
        }
      },
      [_vm._v("\n    Filter your search\n  ")]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }